import TransactionsResource from '@/resources/TransactionsResource';
import DateHelper from "@/helpers/date";
import {AuthService} from "@/main";

export default class Transactions {
    constructor() {
        this.Resource = new TransactionsResource()
    }

    async get (options) {
        const transaction = await this.Resource.get(options)
        return transaction.data.me
    }

    async getFilteredTransactions(options, currentPage = null) {
        let query = this.getFilteredQuery(options)
        let response = await this.Resource.getFilteredTransactionsWithPagination(query, currentPage)
        return response.data
    }

    async getTotalAmount(options, currentPage) {
        let query = this.getFilteredQuery(options)
        let response = await this.Resource.getTotalAmount(query)
        return response.data
    }

    async getFilteredTransactionsWithLimit(options, limit, page = 1) {
        let query = this.getFilteredQuery(options)
        let response = await this.Resource.getFilteredTransactionsWithLimit(query, limit, page)
        return response.data
    }

    getLinkForExport(options, format) {
        let query = this.getFilteredQuery(options)
        const token = AuthService.getToken()
        return process.env.VUE_APP_REST_API + `transactions/export/${format}?token=${token}${query}`
    }

    async getLast(website_ids) {
        const transaction = await this.Resource.getLast(website_ids)
        return transaction.data.me
    }

    getFilteredQuery(options) {
        let query = []

        query.push(this.getTransactionDateRangeForFilterQuery(options))
        query.push(this.getReviewedDateRangeForFilterQuery(options))
        query.push(this.getWebsitesForFilterQuery(options))
        query.push(this.getStatusForFilterQuery(options))
        query.push(this.getVisitorProfilesForFilterQuery(options))
        query.push(this.getNetworksForFilterQuery(options))
        query.push(this.getDisconnectedForFilterQuery(options))
        query.push(this.getProgramNameForFilterQuery(options))

        let queryFilled = query.filter(function (filterQuery) {
            return filterQuery !== ''
        })

        return queryFilled.join('')
    }

    getTransactionDateRangeForFilterQuery(options) {
        if (options.startDate && options.endDate) {
            return `&filter[transaction_date_range]=${DateHelper.formatDate(options.startDate)},${DateHelper.formatDate(options.endDate)}`
        }

        return '';
    }

    getReviewedDateRangeForFilterQuery(options) {
        if (options.reviewedStartDate && options.reviewedEndDate) {
            return `&filter[reviewed_date_range]=${DateHelper.formatDate(options.reviewedStartDate)},${DateHelper.formatDate(options.reviewedEndDate)}`
        }

        return '';
    }

    getWebsitesForFilterQuery(options) {
        if (options.websites && options.websites.length) {
            return '&filter[website_ids]=' + options.websites.join(',')
        }

        return ''
    }

    getStatusForFilterQuery(options) {
        if (options.statuses && options.statuses.length) {
            return '&filter[status_ids]=' + options.statuses.join(',')
        }

        return ''
    }

    getVisitorProfilesForFilterQuery(options) {
        if (options.visitorProfiles && options.visitorProfiles.length) {
            return '&filter[visitor_profiles]=' + options.visitorProfiles.join(',')
        }

        return ''
    }

    getNetworksForFilterQuery(options) {
        if (options.networks && options.networks.length) {
            return '&filter[network_ids]=' + options.networks.join(',')
        }

        return ''
    }

    getProgramNameForFilterQuery(options) {
        if (options.program_name) {
            return '&filter[program_name]=' + options.program_name
        }

        return ''
    }

    getDisconnectedForFilterQuery(options) {
        if (options.hasOwnProperty('disconnected') && options.disconnected !== null) {
            return '&filter[missed_medias]=' + Number(options.disconnected)
        }

        return ''
    }
}
